export enum RoleUser {
  MLSAdministrator = 'MLSAdministrator',
  User = 'User',
  Photographer = 'Photographer'
}

export const RoleUserLabel = new Map<RoleUser, string>([
  [RoleUser.MLSAdministrator, 'MLS Administrator'],
  [RoleUser.User, 'User'],
  [RoleUser.Photographer, 'Photographer']
]);
